module.exports = __webpack_public_path__ + "media/images/thumb_21_staff_list-87e461b5.jpeg";